<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj profil' : 'Dodaj Mieszkańca' }}</v-flex>

    <profile-form :schema="$schema" :edit="!!id" :show="show" />

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ProfileType } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import { CONST } from '@/const.ts';

import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/user.schema';
import ProfileForm from '@/views/profile/ProfileForm';



function emptyData() {
  return {
    login: '',
    profile: {
      firstName: '',
      lastName: '',
      birthDate: '',
      email: '',
      confirmReason: '',
      confirmReasonDescription: '',
      street: '',
      ulic: '',
      homeNumber: '',
      gender: null,
      localNumber: '',
      mainImage: null,
      type: ProfileType.CLIENT,
      terc: CONST.terc,
      woj: CONST.woj,
      pow: CONST.pow,
      gmi: CONST.gmi,
      simc: CONST.simc,
      city: CONST.city,
      postalCode: CONST.postalCode
    }
  };
}

// @vuese
// Modal dodawnia/edycji profilu klienta
// @group Client-Profile
export default {
  components: { Modal, ProfileForm },
  mixins: [manageMixin('client', {}, emptyData)],
  schema
};
</script>
